// extracted by mini-css-extract-plugin
module.exports = {"webviewer":"webviewer__39E7j","title":"title__3w6wY","fill":"fill__2AUzh","loader":"loader__r9yge"};